module.exports = __webpack_public_path__ + "static/media/24UHCHR9.02f055b6.jpg";